import React from 'react';
import { Switch } from '../ui/switch';
import { SettingsRow, RadioGroup } from './shared';
import useAppSettings from '../../hooks/useAppSettings';

export default function EmailNotificationsTab() {
  const { state, update } = useAppSettings();

  return (
    <div>
      <h2 className="text-[18px] font-bold text-[#1A1533]">Email Notifications</h2>
      <div className="mt-5 divide-y divide-[#F1ECFE]">
        <SettingsRow title="Daily Summary Email">
          <Switch checked={state.daily_summary_email} onCheckedChange={(v) => update({ daily_summary_email: v })} />
        </SettingsRow>
        <SettingsRow title="Weekly Summary Email">
          <Switch checked={state.weekly_summary_email} onCheckedChange={(v) => update({ weekly_summary_email: v })} />
        </SettingsRow>
      </div>
      <div className="mt-6 rounded-xl border border-[#ECE6FA] bg-white p-4">
        <p className="text-[13.5px] font-semibold text-[#1A1533]">Emails on AI interview completion</p>
        <div className="mt-3">
          <RadioGroup
            value={state.on_completion || 'created'}
            onChange={(v) => update({ on_completion: v })}
            options={[
              { value: 'created', label: 'Interviews I created' },
              { value: 'all', label: 'All Interviews' },
              { value: 'none', label: 'No emails' },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
